<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="!ReqMode" class="word_keeper">
      <v-card class="ma-4" id="head_height">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-home-edit-outline</v-icon>소속업체 변경 신청 현황
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn @click="Initialize();" icon small>
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
              <div class="d-flex mb-n6">
                <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:230px;" class="mr-4 hidden-md-and-down"/>
                <v-select
                  v-model="cState"
                  @change="GetMoveCorpLog()"
                  :items="zDefaultState"
                  label="진행상태"
                  class="mr-4 hidden-md-and-down"
                  style="width:120px;"
                  dense
                  hide-details
                ></v-select>
                <v-text-field
                  v-model="cNowSearchKeyWord"
                  @keyup.enter="GetMoveCorpLog()"
                  @click:append="GetMoveCorpLog()"
                  append-icon="search"
                  placeholder="신청자 or 접수구성원"
                  label="검색어"
                  class="hidden-md-and-down"
                  style="width:210px;"
                  dense
                  hide-details
                  persistent-placeholder
                ></v-text-field>
              </div>
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:100%" class="hidden-lg-and-up"/>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="cState"
                @change="GetMoveCorpLog()"
                :items="zDefaultState"
                label="진행상태"
                class="hidden-lg-and-up"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="cNowSearchKeyWord"
                @keyup.enter="GetMoveCorpLog()"
                @click:append="GetMoveCorpLog()"
                append-icon="search"
                placeholder="접수구성원"
                label="검색어"
                class="hidden-lg-and-up"
                dense
                hide-details
                persistent-placeholder
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="ma-4">
        <div align="right" class="d-flex pa-2 pr-4 pl-4" id="other_height">
          <div class="text-caption grey--text text--darken-2 font-weight-bold text-justify mr-4">
            <div>*신청완료 후 익일 승인됩니다(평일 기준).</div>
            <div>*소속업체 변경 시 오른쪽 '신청' 버튼을 클릭하세요.</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="ChangeMode()" dark small class="pl-4 pr-2">
            신청<v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>

        <v-data-table
          v-resize="onResize"
          :items="Records"
          :headers="headers"
          :single-select="bSingleSelect"
          @click:row="handleClick"
          @dblclick:row="handleDoubleClick(selected[0])"
          :items-per-page="15"
          item-key="cReqId"
          :height="ChangableHeight"
          fixed-header
        >
          <template v-slot:item.cCreateDateTime="{ item }">
            {{item.cCreateDateTime.substring(0,10)}}
          </template>
          <template v-slot:item.cCorpNm="{ item }">
            <div v-if="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
            <div v-else>{{item.cCorpNmEng}}</div>
          </template>
          <template v-slot:item.cMoveCorpNm="{ item }">
            <div v-if="item.cMoveLocal == 'Y'">{{item.cMoveCorpNmKor}}</div>
            <div v-else>{{item.cMoveCorpNmEng}}</div>
          </template>
          <template v-slot:item.cState="{ item }">
            <v-chip label small :color="getStateColor(item.cState)" dark>{{ getState(item.cState) }}</v-chip>
          </template>
          <template v-slot:item.cOKDateTime="{ item }">
            <div v-if="item.cState != 'R'">{{item.cOKDateTime.substring(0,10)}}</div>
            <!-- {{item.cOKDateTime.substring(0,10)}} -->
          </template>
          <template v-slot:item.cEndComment="{ item }">
            <div v-if="((item.cCustomId == CustomInfo.CustomId && CustomInfo.Manager == 'N') || ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && (item.cCorpId == CustomInfo.CorpId || item.cCustomId == CustomInfo.CustomId))) && item.cState != 'R'">
              <v-btn @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
            </div>
            <!-- <div v-if="(item.cCustomId == CustomInfo.CustomId || ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && item.cCorpId == CustomInfo.CorpId )) && item.cState != 'R'">
              <v-btn :disabled="!((item.cCustomId == CustomInfo.CustomId || ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && item.cCorpId == CustomInfo.CorpId )) && item.cState != 'R')" @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
            </div> -->
          </template>
          <template v-slot:item.cEdit="{ item }">
            <div v-if="item.cCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && item.cState == 'R'" class="d-flex">
              <v-btn @click="OpenDialog(item)" icon><v-icon >mdi-pencil</v-icon></v-btn>
              <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
            </div>
            <!-- <div v-if="item.cCustomId == CustomInfo.CustomId && item.cState == 'R'" class="d-flex">
              <v-btn :disabled="item.cCorpId != CustomInfo.CorpId" @click="OpenDialog(item)" icon><v-icon >mdi-pencil</v-icon></v-btn>
              <v-btn :disabled="item.cCorpId != CustomInfo.CorpId" @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
            </div> -->
          </template>
          <template v-slot:no-data>
            <div class="black--text">{{cNoMsg}}</div>
          </template>
        </v-data-table>
      </v-card>
    </div>


    <div v-else class="word_keeper">
      <v-card class="ma-4">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-home-edit-outline</v-icon>소속업체 변경 신청
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card outlined tile class="ma-4 essetial_card">
          <v-card-text class="pt-6 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <div class="d-flex">
                  <v-text-field v-model="zChargeInfo.cEmailAddr1" @keyup="ResetEmailInfo()" @keyup.enter="GetChargeInfo()" class="mr-2" dense persistent-placeholder>
                    <template v-slot:label>
                      담당자 이메일<strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                  <v-select v-model="zChargeInfo.cEmailAddr2" :items="zEmaillAddr" @click:append-outer="GetChargeInfo()" append-outer-icon="search" auto-select-first dense style="width:160px;">
                    <template v-slot:prepend>
                      <div>@</div>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="zChargeInfo.cUserNm" readonly label="담당자 이름" dense persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            신청자 정보
          </v-card-subtitle>
        </v-toolbar>

        <v-card outlined tile class="ma-4 mt-0">
          <v-card-text class="pt-6 pb-0">
            <v-row class="mb-0">
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.CustomNm"  label="신청자" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.CustomNickId" label="ID" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.LevNm" label="직급" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.Tel" label="휴대전화" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.National" label="국적" dense disabled persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            변경할 업체
          </v-card-subtitle>
          <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down">
            <div>*사업자번호가 동일한 경우에는 협력업체 관리자를 통해 '업체정보 정정' 신청을 바랍니다.</div>
          </div>
        </v-toolbar>
        <v-card-text class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
          <div>*사업자번호가 동일한 경우에는 협력업체 관리자를 통해 '업체정보 정정' 신청을 바랍니다.</div>
        </v-card-text>

        <v-card outlined tile class="ma-4 mt-0 essetial_card">
          <v-card-text class="pt-6 pb-0">
            <v-row class="mb-0">
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.cCorpNm" @keyup="editedItem.cNewCorpId = ''" @keyup.enter="SearchCorpDialog()" @click:append="SearchCorpDialog()" append-icon="search" dense persistent-placeholder ref="cCorpNmRef">
                  <template v-slot:label>
                    업체명<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cChangeReason" dense auto-grow rows="1" persistent-placeholder>
                  <template v-slot:label>
                    변경 사유(상세히) 100자 이내<strong class="red--text">*</strong><br>
                    (상세히)<br>
                    100자 이내
                  </template>
                </v-textarea>
                <!-- <v-text-field v-model="CustomInfo.CustomNickId" label="ID" dense disabled persistent-placeholder></v-text-field> -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-divider class="mr-4 ml-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            첨부파일
          </v-card-subtitle>
          <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down">
            <div>*첨부파일 내 <strong class="red--text">주민등록번호 뒷자리는 삭제 후</strong> 등록 바랍니다. 미삭제 시 부결 처리 됩니다.</div>
          </div>
        </v-toolbar>
        <v-card-text class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
          <div>*사업자번호가 동일한 경우에는 협력업체 관리자를 통해 '업체정보 정정' 신청을 바랍니다.</div>
        </v-card-text>
        <v-card-text>
          <v-card class="d-flex flex-wrap essetial_card" flat outlined tile>
            <v-card width="170" flat class="ml-4 mr-4 pa-4 essetial_card">
              <v-img
                :aspect-ratio="2/1"
                :src="sNowPath"
                contain
                style="height:100px"
                max-height="150px"
              ></v-img>
              <v-file-input
                v-on:change="onSelFile(NowSelFile)"
                v-model="NowSelFile"
                class="mt-2"
                accept="image/png"
                placeholder="파일선택"
                dense
              ></v-file-input>
            </v-card>
            <v-card class="essetial_card" flat>
              <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
                <p>재직증명서<span class="red--text">*</span></p>
              </v-card-subtitle>
              <v-card-text class="text-caption">
                JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
                다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                (첨부 할 수 있는 파일의 최대 크기는 10MB 까지 입니다)
              </v-card-text>
            </v-card>
          </v-card>
        </v-card-text>

        <!-- <div class="ma-4 mt-0">
          <v-card class="d-flex essetial_card" tile outlined>
            <v-card height="170" flat class="ml-4 mr-4 pa-4 essetial_card">
              <v-img
                :aspect-ratio="1/1"
                :src="sNowPath"
                contain
                style="height:100px"
                max-width="150px"
                max-height="150px"
              ></v-img>
              <v-file-input
                v-on:change="onSelFile(NowSelFile)"
                v-model="NowSelFile"
                class="mt-2"
                accept="image/png"
                placeholder="파일선택"
                dense
              ></v-file-input>
            </v-card>
            <v-card class="essetial_card" flat>
              <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
                <p>재직증명서<span class="red--text">*</span></p>
              </v-card-subtitle>
              <v-card-text class="text-caption">
                JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
                (첨부 할 수 있는 파일의 최대 크기는 10MB까지 입니다)<br>
                다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
              </v-card-text>
            </v-card>
          </v-card>
        </div> -->
        <div align="center" class="ma-4 pb-4">
          <v-divider class="mb-4"></v-divider>
          <v-btn @click="BackStatus()" width="100px" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>목록</v-btn>
          <v-btn @click="SetMoveCorpLog()" width="100px" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
        </div>
      </v-card>
    </div>

    <SearchCorp ref="SearchCorpRef" @GetCorpInfo="GetCorpInfo"/>
    <EditMoveDialog ref="EditMoveDialogRef" @ChangeReq="ChangeReq"/>
    <DelDialog ref="DelDialogRef" @DelMoveCorpData="DelMoveCorpData"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>
<script>
import Util from "../Util.js";
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import { mapState } from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';

import SearchCorp from "./SearchCorp.vue";
import EditMoveDialog from "../components/EditMoveDialog.vue";
import DelDialog from '../components/DelDialog.vue'
import ResponseDialog from '../components/ResponseDialog.vue'

export default {
  components: {
    IronDate,
    SearchCorp,
    EditMoveDialog,
    DelDialog,
    ResponseDialog,
  },
  data: () => ({
    bSingleSelect : true,
    bApplyDate : false,
    cNoMsg : "",
    ReqMode : false,
    loading : false,
    NowSelFile : null,
    sNowPath : "",
    sNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    cNowSearchKeyWord : "",
    cState : "ALL",
    ChangableHeight : "",
    
    editedItem : {
      // cState : "ALL",
      cCorpNm : "",
      cChangeReason : "",
      cFileId : "",
      // cThumbnailPath : "",
      cNewCorpId : "",
      // sNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
      // sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
      // sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    },
    defaulteditedItem : {
      // cState : "ALL",
      cCorpNm : "",
      cChangeReason : "",
      cFileId : "",
      // cThumbnailPath : "",
      cNewCorpId : "",
      // sNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
      // sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
      // sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    },
    zChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cEmailAddr1 : "",
      cEmailAddr2 : "",
    },
    Records : [],
    headers : [
      { text: 'No', value: 'sNum', width : "10"},
      { text: '신청일자', value: 'cCreateDateTime',width : "120" },
      { text: '신청자', value: 'cCustomNm' },
      { text: '소속업체', value: 'cCorpNm' },
      { text: '변경할 업체', value: 'cMoveCorpNm' },
      { text: '접수구성원', value: 'cChargeUserNm' },
      { text: '진행상태', value: 'cState' },
      { text: '결재일', value: 'cOKDateTime'},
      { text: '의견', value: 'cEndComment',width:"80",align : "center"},
      { text: '작업', value: "cEdit", width : "80", align : "center"},
    ]
  }),

  computed: {
    ...mapState(["CustomInfo","zDefaultState","zFileType","FMaxSize3","zEmaillAddr"]),
  },

  mounted () {
    this.Initialize();
  },

  created () {
  },

  methods: {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight
      let h3 = document.getElementById('other_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - h3 - 137

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }      
    },

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item){
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId != this.CustomInfo.CorpId) return
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId == this.CustomInfo.CorpId && this.CustomInfo.Manager == "N") return
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId == this.CustomInfo.CorpId && this.CustomInfo.Manager != "N" && item.cState == "R") return

      if (this.selected.length > 0 || item.cReqId != undefined){
        this.OpenDialog(item)
      }
    },

    BackStatus() {
      this.editedItem  = Object.assign({}, this.defaulteditedItem);
      this.sNowPath = ""
      this.NowSelFile = null
      this.Initialize();
    },

    Initialize() {
      this.ReqMode = false;
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
      this.zChargeInfo.cEmailAddr1 = ""
      this.zChargeInfo.cEmailAddr2 = this.zEmaillAddr[0]
      this.bApplyDate = true;
      this.cNowSearchKeyWord = "";
      this.cState = "ALL";
      this.sStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.sEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.sNowSelectDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.GetMoveCorpLog();
      setTimeout(() => {
        this.onResize();
      }, 10);
    },

    ChangeMode() {
      this.ReqMode = true;
      setTimeout(() => {
        this.$refs.cCorpNmRef.focus()
      }, 10);
    },

    OpenDialog(item) {
      if (item.cState == BasicInfo.REQ_TYPE_MOVE_STATE_REQ) {
        if (item.cCorpId == this.CustomInfo.CorpId) {
          let EditIndex = this.Records.indexOf(item);
          this.$refs.EditMoveDialogRef.ShowDialog(item,EditIndex);
        }
      } else {
        this.ShowComment(item,item.cState)
        // this.$refs.ResponseDialogRef.ShowDialog(item,this.getState(item.cState),false)
        // this.$refs.ResponseDialogRef.ShowDialog(item,this.getState(item.cState),false)
      }
    },

    ShowComment(oitem,StateNm) {
      this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),false)
    },

    ChangeReq(Result,index) {
      this.Records[index].cMoveLocal = Result.cMoveLocal
      this.Records[index].cMoveCorpNmEng = Result.cMoveCorpNmEng
      this.Records[index].cMoveCorpNmKor = Result.cMoveCorpNmKor
      // this.Records[index].cThumbnailPath = Result.cThumbnailPath
      this.Records[index].cFileId = Result.cFileId
      this.Records[index].cFileNm = Result.cFileNm
      this.Records[index].cChangeReason = Result.cChangeReason
      this.Records[index].cNewCorpId = Result.cNewCorpId
    },

    // 삭제 확인 다이올로그 창 열기
    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("Move",item,this.Records.indexOf(item));
    },

    // 확인 버튼 클릭 시 삭제 함수 실행하기
    DelMoveCorpData(index,item){
      this.DelMoveCorpLog(index,item)
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
      this.GetMoveCorpLog()
    },

    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          // this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailPath

          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB 까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      this.loading = true
      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
        this.loading = false;
      }
      try {
        this.loading = false;
        reader.readAsDataURL(NowSelFile)
      }
      catch (error) {
        // this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailPath
        this.loading = false;
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    // 파일 저장하기
    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadauthfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadAuthFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId+"&CustomId="+this.CustomInfo.CustomId+"&SiteId="+this.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization" : this.CustomInfo.Token,
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    getStateColor(cState){
      return this.zDefaultState.find((e) => {return e.value == cState})?.color
    },

    getState(cState){
      return this.zDefaultState.find((e) => {return e.value == cState})?.text
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    GetMoveCorpLog() {
      this.Records = [];
      var posData = {};

      posData = {
        Manager : this.CustomInfo.Manager,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        State : this.cState,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
        ApplyDate : this.bApplyDate,
        NowSearchKeyWord : this.cNowSearchKeyWord,
      }
      axios
        .post(process.env.VUE_APP_UIL_API + "GetMoveCorpLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for(let k = 0; k < res.data.Result.length; k ++){
                res.data.Result[k].sNum = k + 1
              }
            } else {
              this.ShowNoResultMsg()
            }

            this.Records = res.data.Result
            this.bApplyDate = false;
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
    
    ResetEmailInfo(){
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
    },
    
    GetChargeInfo(){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        Email : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetChargeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              EventBus.$emit("onShowMsgBox","입력하신 이메일을 다시 확인하여 주세요.","입력하신 이메일과 일치하는 담당자가 없습니다.");
            } else {
              this.zChargeInfo.cUserId = res.data.Result[0].cUserId
              this.zChargeInfo.cUserNm = res.data.Result[0].cUserNm
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    async SetMoveCorpLog() {
      if (this.zChargeInfo.cUserId == "") {
        EventBus.$emit("onShowMsgBox", "담당자가 선택 되지 않았습니다.","검색 아이콘을 클릭 하여 담당자를 검색 및 선택하여 주세요.");
        return
      }
      if (this.editedItem.cNewCorpId == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "변경 된 업체를 입력(선택)하여 주세요.");
        return
      }
      
      if (this.editedItem.cChangeReason == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "변경 사유를 입력하여 주세요.");
        return
      }

      if (this.editedItem.cChangeReason.length > 100){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 정확하게 입력하여 주세요.", "변경 사유는 100자 이내로 입력하여 주세요.");
        return
      }
      
      if (this.NowSelFile == null){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "재직증명서를 첨부하여 주세요.");
        return
      }


      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          this.editedItem.cFileId = res.data.FileId;
          // this.editedItem.cThumbnailPath = res.data.ThumbnailPath;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        ChargeUserId : this.zChargeInfo.cUserId,
        // ChargeUserNm : this.zChargeInfo.cUserNm,
        ChargeEmail : Util.AddEmail1and2(this.zChargeInfo.cEmailAddr1,this.zChargeInfo.cEmailAddr2),
        // ChargeEmail : Util.AddEmail1and2(this.zChargeInfo.cEmailAddr1,this.zChargeInfo.cEmailAddr2),
        CorpId : this.CustomInfo.CorpId,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        NewCorpId : this.editedItem.cNewCorpId,
        ChangeReason : this.editedItem.cChangeReason,
        FileId  : this.editedItem.cFileId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetMoveCorpLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.editedItem.cNewCorpId = ""
            this.editedItem.cCorpNm = ""
            this.editedItem.cChangeReason = ""
            this.sNowPath = ""
            this.NowSelFile = null
            this.Initialize();
            EventBus.$emit("onShowMsg",false,  "신청이 완료 되었습니다.");
          // } else if (res.data.ResultCd == "02") {
          //   EventBus.$emit("onShowMsgBox", "관리자에게 문의 바랍니다.", res.data.Msg);
          } else if (res.data.ResultCd == "06") {
            this.$store.dispatch('logout',"DelCustomId");
            EventBus.$emit("onShowMsgBox", "삭제 처리된 아이디 입니다.", "로그인 화면으로 이동합니다.");
          } else {
            EventBus.$emit("onShowMsgBox", "신청에 실패 하였습니다.", res.data.Msg);
          }
        })
        .catch(err => {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 업체물품 반입 신청 삭제하기
    DelMoveCorpLog(index,item){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        ReqId : item.cReqId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "DelMoveCorpLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index,1)
            for (let i = 0; i < this.Records.length;i ++){
              this.Records[i].sNum = i+1
            }
            EventBus.$emit("onShowMsg",false,"삭제가 완료되었습니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },
    
    SearchCorpDialog() {
      this.$refs.SearchCorpRef.Open("MoveCorp",this.editedItem.cCorpNm);
    },

    GetCorpInfo(Data) {
      if (Data != undefined) {
        this.editedItem.cNewCorpId = Data.cCorpId
        if (Data.cLocal == 'Y') {
          this.editedItem.cCorpNm = Data.cCorpNmKor
        } else {
          this.editedItem.cCorpNm = Data.cCorpNmEng
        }
      }
    },
  }
};
</script>

<style>

</style>